import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
export const getHelpMeValues = clientData => {
  let values = ['Help me with', 'through'];
  if (!_isEmpty(_get(clientData, 'pageText.helpMeValues'))) {
    const {
      pageText: { helpMeValues },
    } = clientData;
    values = helpMeValues;
  }

  return values;
};
